let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ld26n")).then(() => parcelRequire('4duqz'));